export default __webpack_public_path__ + "static/media/0e.096afe9e.jpg";